import React from "react";
import { OcDataTable } from "oc/components/data-table";

type MyTimeWithoutExaminerTableProps = {
  tableDef: any;
  filteredTableDef?: any;
  tableId: string;
  tableData: any;
  setTableData: (data: any) => void;
  onSelectRow: (row: any) => void;
  data: any[];
  loading: boolean;
  selectedRowId: string | number | null;
};

export const MyTimeWithoutExaminerTable = ({
  tableDef,
  filteredTableDef,
  tableId,
  tableData,
  setTableData,
  onSelectRow,
  data,
  loading,
  selectedRowId,
}: MyTimeWithoutExaminerTableProps) => {
  const list = {
    rows: data,
    total: data?.length ?? 0,
  };

  return (
    <OcDataTable
      tableDef={tableDef}
      filteredTableDef={filteredTableDef}
      tableId={tableId}
      tableData={tableData}
      setTableData={setTableData}
      onSelectRow={onSelectRow}
      data={list}
      loading={loading}
      pagination
      localPaging
      selectedRowId={selectedRowId ?? undefined}
    />
  );
};

export default MyTimeWithoutExaminerTable;
